import { ReactNode } from 'react';

import { createFetchContext } from '../../../../components/contexts/FetchContextFactory';
import { getAcademicOfferFormData } from '../api';
import { NonStructuredAcademicOfferFormData } from '../types';

const {
  FetchProvider: AcademicOfferFormDataProvider,
  FetchConsumer: AcademicOfferFormDataConsumer,
  useFetch: useAcademicOfferFormData,
} = createFetchContext<undefined, NonStructuredAcademicOfferFormData>();

interface Props {
  children: ReactNode;
  fetchImmediately?: boolean;
}

export const AcademicOfferFormDataLoader = ({
  children,
  fetchImmediately = true,
}: Props) => {
  return (
    <AcademicOfferFormDataProvider
      request={getAcademicOfferFormData}
      fetchImmediately={fetchImmediately}
      defaultQuery={undefined}
    >
      {children}
    </AcademicOfferFormDataProvider>
  );
};

export {
  AcademicOfferFormDataConsumer,
  AcademicOfferFormDataProvider,
  useAcademicOfferFormData,
};
